"use client";
import { useLocaleCtx } from "@/contexts/locale";
import NextLink from "next/link";
import React from "react";
import { UrlObject } from "url";

interface Props
  extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  href: string | UrlObject;
  children?: React.ReactNode;
}

const Link = React.forwardRef<HTMLAnchorElement, Props>(
  ({ children, href, ...props }, ref) => {
    const { lang } = useLocaleCtx();

    return (
      <NextLink
        ref={ref}
        href={
          typeof href === "string"
            ? `/${lang}${href}`
            : { ...href, pathname: `/${lang}${href?.pathname ?? ""}` }
        }
        locale={lang}
        {...props}
      >
        {children && children}
      </NextLink>
    );
  },
);

export default Link;
